import classNames from "classnames";
import Color from "color";
import BookingPill from "PFApp/components/pills/booking_pill";
import radii from "PFTheme/tokens/radii";
import React, { MouseEvent } from "react";

import css from "../bars.module.scss";
import BookingBarEdge from "./booking_bar_edge";
import { useBookingBarContext } from "./booking_bar_provider";
import { BookingPillContent } from "./booking_pill_content";

interface BookingBarContentProps {
  hover: boolean;
  onLeftEdgeMouseDown?: (event: MouseEvent) => void;
  onRightEdgeMouseDown?: (event: MouseEvent) => void;
  classes: Record<string, string>;
}

export const BookingBarContent = ({
  hover,
  onLeftEdgeMouseDown,
  onRightEdgeMouseDown,
  classes
}: BookingBarContentProps): JSX.Element => {
  const {
    bar: { width },
    isEditable,
    isSelectModeEnabled,
    draggingMode,
    draggingStartDate,
    draggingEndDate,
    category,
    isSplittable,
    shouldBookingBeSelected,
    isDurationBreakdown
  } = useBookingBarContext();
  const showLeftEdge =
    width > 60 && (draggingMode === "start" || (hover && draggingMode === null)) && !isSplittable;
  const showRightEdge =
    width > 60 && (draggingMode === "end" || (hover && draggingMode === null)) && !isSplittable;

  return (
    <>
      {isEditable && showLeftEdge && (
        <BookingBarEdge
          className={css.leftEdge}
          isDragged={draggingMode === "start"}
          onMouseDown={onLeftEdgeMouseDown}
          startDate={draggingStartDate}
          endDate={draggingEndDate}
        />
      )}
      <BookingPill
        category={category}
        className={classNames(css.pill, classes.pill, {
          [css.lightCategoryColor]: !category?.color || Color(category.color).isLight(),
          [css.overlayMode]: isSplittable || isDurationBreakdown
        })}
        withNoCategoryIcon={width > 45}
        style={{
          borderWidth: isSelectModeEnabled ? (shouldBookingBeSelected() ? radii.radiusSm : 0) : undefined
        }}
      >
        <BookingPillContent />
      </BookingPill>
      {isEditable && showRightEdge && (
        <BookingBarEdge
          className={css.rightEdge}
          isDragged={draggingMode === "end"}
          onMouseDown={onRightEdgeMouseDown}
          startDate={draggingStartDate}
          endDate={draggingEndDate}
        />
      )}
    </>
  );
};
